module.exports = __webpack_public_path__ + "static/media/login.8eac7879.svg";